import React from "react"
import { string, node, func } from "prop-types"
import {CardLink, CardButton} from "./Cards.style"

const Cards = ({ children, title, onClick, className, to }) => {
  const classNameID = `m-card`
  if (to) {
    return (
      <CardLink to={to} onClick={onClick} className={className}>
        {children}
        <div className={`${classNameID}__title`} > {title} </div>
      </CardLink>
    )
  }
  return (
    <CardButton onClick={onClick} className={className}>
      {children}
      <div className={`${classNameID}__title`} > {title} </div>
    </CardButton>
  )
}

Cards.propTypes = {
  children: node.isRequired,
  title: string,
  onClick: func,
  className: string,
  to: string,
}

Cards.defaultProps = {
  children: null,
  title: "",
  onClick: () => null,
  className: "",
  to: "",
}

export default Cards
